var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Head-container"},[_c('hd-search'),_c('div',{staticClass:"hd_l"},[_c('hd-login')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }